// const VAAYU_URL = "http://127.0.0.1/vaayu";
// const VAAYU_URL = "http://127.0.0.1:8000";
const VAAYU_URL =  "https://vaayu.lk";
const conf = {
    serverUrl:  VAAYU_URL,
    // basePath: `public/api`,
    basePath: `api`
}

export default conf;